var angular = require('angular');

var Customer = require('./customer');
var Delivery = require('./delivery');
var toDate = require('./util').toDate;
var formatZip = require('./util').formatZip;

function DistributionCustomer(customer, distribution) {
  angular.extend(this, customer);

  this.route = distribution.findRoute(customer.routeId);
  this.estimatedTimestampDone = toDate(customer.estimatedTimestampDone);

  this.deliveries = customer.deliveries
    .map(function(delivery) {
      return new Delivery(delivery, this);
    }, this)
    .sort(function(d1, d2) {
      return d1.product.localeCompare(d2.product);
    });

  this.notCancelled = Customer.prototype.notCancelled;
  this.delayed = Customer.prototype.delayed;
  this.deliveryStatusTimestamp = Customer.prototype.deliveryStatusTimestamp;
}

DistributionCustomer.prototype.fullAddress = function() {
  return this.address + ', ' + formatZip(this.zip, this.country) + ' ' + this.city;
};

DistributionCustomer.prototype.addNotification = function(notification) {
  this.notifications.push(notification);
};

DistributionCustomer.prototype.updateImage = function(image) {
  this.imageUrl = image.imageUrl;
};

DistributionCustomer.prototype.updateDelivery = function(delivery) {
  var newDelivery = new Delivery(delivery, this);
  var oldDelivery = this.findDelivery(delivery.id);

  if (oldDelivery) {
    angular.extend(oldDelivery, newDelivery);
  } else {
    // Could not find delivery, let's add it to the customer
    this.deliveries.push(newDelivery);
  }
};

DistributionCustomer.prototype.deleteDelivery = function(deliveryId) {
  this.deliveries = this.deliveries.filter(function(delivery) {
    return delivery.id !== deliveryId;
  });
};

DistributionCustomer.prototype.findDelivery = function(deliveryId) {
  return this.deliveries.filter(function(delivery) {
    return delivery.id === deliveryId;
  })[0];
};

module.exports = DistributionCustomer;



/*****************
 ** WEBPACK FOOTER
 ** ./src/js/lib/distributionCustomer.js
 ** module id = 169
 ** module chunks = 1
 **/